import Vue from 'vue'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'


export default {
	namespaced: true,
	state: {
		loading: {},
		questionnaire: {},
		userListObj: {
			keyUserList: [],
			questionId: '',
			userList: []
		}
	},
	actions,
	getters,
	mutations
}
